// extracted by mini-css-extract-plugin
export default {"clear-timing":"LiveAuctionAlert_clear-timing__kn5fh"};